<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت تخفیفات جشنواره ای</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                <v-card>
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md7 lg7 xl7 style="padding-right:15px;padding-left:15px;">
                                <v-text-field outlined dense color="#262d47" placeholder="جستجو" v-model="searchcategory" append-icon="fas fa-search"></v-text-field>   
                            </v-flex>
                            <v-flex xs12 sm12 md5 lg5 xl5 style="padding-right:15px;padding-left:5px;">
                                <v-btn outlined color="#4CAF50" @click="CatCreationDialog = true" dark><v-icon small style="padding-left:5px;">fa fa-plus</v-icon>&nbsp;کد تخفیف جدید</v-btn>&nbsp;
                                <JsonExcel style="display: inline-block;padding-left: 5px;" :data="originalItems" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExportDataColumns">
                                  <v-btn outlined color="#2a2d45" dark><v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل</v-btn>&nbsp;
                                </JsonExcel>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table no-data-text="رکوردی یافت نشد" no-results-text="رکوردی یافت نشد" :footer-props="{'items-per-page-text':'آیتم در هر صفحه :','items-per-page-all-text':'همه'}"  items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingItems" :headers="CatTableHeader" :search="searchcategory" :items="CatTableItems">
                            <template v-slot:[`item.status`]="{ item }">
                               <v-btn small text color="#D32F2F" @click="ActiveItem(item.id)" dark v-if="!item.status">غیر فعال</v-btn>
                               <v-btn small text color="#2E7D32" @click="DisableItem(item.id)" dark v-else> فعال</v-btn>
                            </template>
                            <template v-slot:[`item.operation`]="{ item }">
                                <v-btn text icon small color="red accent-4" @click="confirmDeleteItem(item.id)"><v-icon small>fas fa-trash</v-icon></v-btn>&nbsp;
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <template><!--Add New Cat From Dialog-->
            <v-dialog max-width="500"  v-model="CatCreationDialog">
                <v-card>
                  <v-card-title style="padding:0px !important">
                     
                  </v-card-title>
                  <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                            <v-layout row wrap style="flex-wrap:wrap-reverse !important;">
                                <v-flex xs12 sm12 md12 lg12 xl12 style="padding:15px;padding-top:0px !important;"><!--Register New Color From-->
                                    
                                    <v-text-field color="#2a2d45" outlined dense v-model="AttributeTitle" label="عنوان" ></v-text-field>
                                    <v-text-field color="#2a2d45" outlined dense v-model="Discount" label="درصد تخفیف" ></v-text-field>
                                    <v-row v-if="!AttrStatus">
                                        <v-autocomplete
                                            v-for="i in MAXCATLEVELCOUNT"
                                            :key="'newprodCatSelect' + i"
                                            no-data-text="دسته بندی یافت نشد"
                                            color="#2a2d45"
                                            item-text="pC_Title"
                                            item-value="pC_Id"
                                            :multiple="(i == MAXCATLEVELCOUNT)"
                                            :items="NewProdCatItems['cat' + i]"
                                            @input="NewProdCatChanged(i + 1, $event)"
                                            @change="NewProdCatChanged(i + 1, $event)"
                                            :label="'دسته بندی سطح ' + i"
                                            outlined
                                            dense
                                            ref="TiggerChange"
                                            v-model="NewProdCatModels['cat' + i]"
                                        ></v-autocomplete>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="8"><v-chip color="blue" dark v-if="AttrStatus">تمام محصولات</v-chip><v-chip color="green" dark v-if="!AttrStatus">گروه محصولات</v-chip></v-col>
                                        <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                            <v-switch v-model="AttrStatus" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                        </v-col>
                                    </v-row>
                                    <v-btn style="margin-top:20px;" @click="registerItem" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
        <template><!--Delete Confirm Dialog-->
            <v-dialog max-width="450" persistent v-model="ConfirmItemDeleteDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                            <v-toolbar-title style="color:orange">حذف دائمی</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon color="orange" @click="ConfirmItemDeleteDialog = false" small>fa fa-times</v-icon>
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text style="padding-top:15px;">
                        <v-alert type="error" outlined>
                            کاربر گرامی ؛ رکورد مورد نظر به همراه تمام زیر مجموعه های آن به صورت دائمی حذف خواهند شد.ادامه میدهید؟
                        </v-alert>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn outlined :loading="deleteBtnLoading" color="error" @click="DeleteItem"><v-icon small style="padding-left:5px;">fa fa-trash</v-icon>&nbsp; بله</v-btn>&nbsp;
                        <v-btn outlined @click="ConfirmItemDeleteDialog = false" color="info"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp; خیر</v-btn>&nbsp;
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>
<style>
.v-color-picker__canvas canvas
{
    display: block !important;
    min-width: 100% !important;
    height: 100% !important;
}
</style>
<script>

const axios = require("axios");
const ApiUrl = require('../../constant/apiurl');
const MSGHNDL = require('../../constant/MessageHandler');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import JsonExcel from 'vue-json-excel'
export default {
   name:"festival",
   components: 
   {
      Loading,
      JsonExcel
        
    },
    data:()=> ({
        StartDateMenu:false,
        AttrType:"",
        ConfirmItemDeleteDialog:false,
        isLoading:false,
        CatCreationDialog:false,
        searchcategory:"",
        isLoadingItems:false,
        AttrStatus:false,
        UseInSearch:false,
        CatTableHeader:
        [
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"عنوان ",value:"title",sortable:true,align:"right"},
            {text:"نوع ",value:"typeStr",sortable:true,align:"right"},
            {text:"درصد تخفیف",value:"discount",sortable:true,align:"right"},
            {text:"وضعیت",value:"status",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        CatTableItems:
        [
        ],
        AttributeTitle:"",
        AttrSortField:"",
        originalItems:[],
        inEditingItem:false,
        EditSelectedItem:{},
        deleteItemId:0,
        deleteBtnLoading:false,
        ExportDataColumns:{
            "کد":"cP_Id",
            "عنوان":"cP_Title",
            "نوع کد تخفیف ":"cP_Type",
            "استفاده در جستجو":"cP_UseInSearch",
            "ترتیب نمایش":"cP_SortField",
            "وضعیت":"cP_Status"
        },
        AttributeTypeItems:[
            {text:"محصولات فیزیکی",value:1},
            {text:"محصولات دیجیتالی",value:2},
            {text:"دوره های آموزشی",value:3},
        ],
        date:"",
        sdate:"",
        StartDate:"",
        EndDateMenu:false,
        EndDate:"",
        Discount:0,
        MAXCATLEVELCOUNT: 0,
        CategoryItems: {
      cat1: [],
      cat2: [],
      cat3: [],
      cat4: [],
      cat5: [],
      cat6: [],
      cat7: [],
      cat8: [],
      cat9: [],
      cat10: [],
      cat11: [],
      cat12: [],
      cat13: [],
      cat14: [],
      cat15: [],
      cat16: [],
      cat17: [],
      cat18: [],
      cat19: [],
      cat20: [],
    },
    NewProdCatItems: {
      cat1: [],
      cat2: [],
      cat3: [],
      cat4: [],
      cat5: [],
      cat6: [],
      cat7: [],
      cat8: [],
      cat9: [],
      cat10: [],
      cat11: [],
      cat12: [],
      cat13: [],
      cat14: [],
      cat15: [],
      cat16: [],
      cat17: [],
      cat18: [],
      cat19: [],
      cat20: [],
    },
    NewProdCatModels: {
        cat1: [],
      cat2: [],
      cat3: [],
      cat4: [],
      cat5: [],
      cat6: [],
      cat7: [],
      cat8: [],
      cat9: [],
      cat10: [],
      cat11: [],
      cat12: [],
      cat13: [],
      cat14: [],
      cat15: [],
      cat16: [],
      cat17: [],
      cat18: [],
      cat19: [],
      cat20: [],
    },
    CatSelectionModels: [],

    }),
    async created()
    {
        let vm = this;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
        await vm.getAllowedMaxLevelCount();
       await this.loadItems();
    },
    methods:{
     async NewProdCatChanged(lvl, val) {
      let vm = this;
      if (lvl <= vm.MAXCATLEVELCOUNT) {
        let Model = {};
        Model.Id = val;
        let index = "cat" + lvl;
        await axios
          .post(ApiUrl.getCategoryChilds, Model)
          .then(async (res) => {
            let data = res.data;
            if (data.status) {
              vm.$data["NewProdCatItems"][index] = data.data.childs;

              console.warn(data.data.attributes);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
      }
    },

     async getAllowedMaxLevelCount() {
      let vm = this;

      await axios
        .post(ApiUrl.getCategoiesOfLevelOne)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            vm.MAXCATLEVELCOUNT = data.data.max;
            for (let i = 1; i <= vm.MAXCATLEVELCOUNT; i++) {
              let index = `cat${i}`;
              vm.CategoryItems[index] = [];
              vm.CatSelectionModels[index] = "";
            }
            console.warn(data.data.cats);
            vm.CategoryItems["cat1"] = data.data.cats;
            vm.NewProdCatItems["cat1"] = data.data.cats;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

        parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
        async DeleteItem()
        {
            let vm = this;
            vm.deleteBtnLoading = true;

            await axios.post(ApiUrl.DeleteFestival+"/"+vm.deleteItemId)
            .then(async (res)=>{
                vm.deleteBtnLoading = false;
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    vm.ConfirmItemDeleteDialog = false;
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                vm.deleteBtnLoading = false;
                MSGHNDL.ERR(err);
            });
        },
        confirmDeleteItem(id)
        {
            let vm = this;
            vm.ConfirmItemDeleteDialog = true;
            vm.deleteItemId = id;
        },
        async ActiveItem(id)
        {
            let vm = this;
            let Model = {};
            Model.fest = id;
            await axios.post(ApiUrl.ActiveFestival+"/"+id,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async DisableItem(id)
        {
            let vm = this;
            let Model = {};
            Model.fest = id;
            await axios.post(ApiUrl.DisableFestival+"/"+id,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        cancelEditItem()
        {
            let vm = this;
            vm.CatCreationDialog = false;
            vm.AttributeTitle = "";
            vm.inEditingItem = false;
            vm.EditSelectedItem = {};
        },
        editItem(item)
        {
            let vm = this;
            vm.CatCreationDialog = true;
            vm.AttributeTitle = item.cP_Title;
            vm.AttrSortField = item.cP_SortField;
            vm.AttrType = item.cP_Type;
            vm.UseInSearch = item.cP_UseInSearch;
            vm.AttrStatus = item.cP_Status;
            vm.inEditingItem = true;
            vm.EditSelectedItem = item;
        },
        async loadItems()
        {
            let vm = this;
            vm.isLoadingItems = true;

            await axios.post(ApiUrl.LoadAllFestival).then((res)=>{
                vm.isLoadingItems = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.CatTableItems = data.data;
                    vm.originalItems = data.data;
                    
                    console.warn(data.data);
                    
                }
            }).catch((err)=>{
                vm.isLoadingItems = false;
                console.error(err);
            });
        },
        async registerItem()
        {
            let vm = this;
            let Model = {};

            Model.Categories = vm.NewProdCatModels["cat" + vm.MAXCATLEVELCOUNT];
            Model.Title = vm.AttributeTitle;
            Model.Type = vm.AttrStatus ? 1 : 2;
            Model.Discount = vm.Discount;
            await axios.post(ApiUrl.AddFestival,Model).then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    vm.loadItems();
                    vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
        }
    }
}
</script>